<template lang="pug">
  .tags.has-addons
    span.tag.is-dark.is-medium {{ auto.pg }}
    a.tag.is-delete.is-medium(@click="selectAuto()")
</template>

<script>
  export default {
    name: 'AutosRecepcion',
    props: {
      auto: { type: Object, required: true }
    },
    methods: {
      selectAuto () {
        this.$emit('select', this.auto.id)
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/sca_Componentes/acceso/AutosRecepcion.vue